{
  "adultShort": "{n} взр",
  "childShort": "{n} дет",
  "infantShort": "{n} млад",
  "youthShort": "{n} мол"
}
